import React from "react";
import "./ProductQuantity.css";
import { connect } from "react-redux";
import { setQuantity } from "../redux/reducers/threekitSlice";
import productValues from "../assets/fabricProductValues";
import { assetIdToProductType } from "../services/skuMapper";
import styled from "styled-components";
class ProductQuantity extends React.Component {
  getMax = () => {
    return productValues[assetIdToProductType(this.props.assetId)].max;
  };
  getMin = () => {
    return productValues[assetIdToProductType(this.props.assetId)].min;
  };
  changeQuantityValue = (min, max, action) => (element) => {
    // Get input

    const newQuantity = parseInt(
      action == "add" ? this.props.quantity + 1 : this.props.quantity - 1
    );
    if (max != undefined && min != undefined) {
      if (newQuantity <= max && newQuantity >= min)
        this.props.setQuantity(newQuantity);
    } else {
      if (newQuantity >= min || newQuantity >= 1)
        this.props.setQuantity(newQuantity);
    }
  };

  changeQuantity = () => (element) => {
    const newQuantity = parseInt(element.target.value);
    this.props.setQuantity(newQuantity);
  };
  checkQuantity = (min, max) => (element) => {
    if (isNaN(this.props.quantity) || this.props.quantity == undefined) {
      this.props.setQuantity(min || 1);
      return;
    }

    if (max != undefined && min != undefined) {
      if (this.props.quantity > max) this.props.setQuantity(max);
      if (this.props.quantity < min) this.props.setQuantity(min);
    } else {
      if (this.props.quantity < 1) this.props.setQuantity(1);
    }
  };
  render() {
    return (
      <Container>
        <Title>Quantity</Title>
        <InnerContainer>
          <Minus
            onClick={this.changeQuantityValue(
              this.getMin(),
              this.getMax(),
              "subtract"
            )}
          >
            -
          </Minus>
          <Input
            onChange={this.changeQuantity()}
            onBlur={this.checkQuantity(this.getMin(), this.getMax())}
            value={this.props.quantity}
            min={this.getMin()}
          />
          <Plus
            onClick={this.changeQuantityValue(
              this.getMin(),
              this.getMax(),
              "add"
            )}
          >
            +
          </Plus>
        </InnerContainer>
      </Container>
    );
  }
}
function mapStateToProps(state) {
  return { quantity: state.threekit.quantity, assetId: state.threekit.assetId };
}
export default connect(mapStateToProps, { setQuantity })(ProductQuantity);

const Input = styled.input`
  border: none;
  -webkit-appearance: none;
  margin: 0;
  flex: 1;
  /* Firefox */
  -moz-appearance: textfield;
  width: 50px;
  text-align: center;
  font-size: 18px;
`;

const Icon = styled.button`
  padding: 12px 19px;
  color: var(--color-wine);
  background: none;
  border: none;
  font-size: 25px;
`;
const Minus = styled(Icon)``;
const Plus = styled(Icon)``;
const Container = styled.div``;
const InnerContainer = styled.div`
  display: inline-flex;
  background: white;
  border: 1px solid #a8a8a8;
`;

const Title = styled.p`
  margin: 0;
  padding-bottom: 7px;
  font-size: 14px;
  text-align: left;
`;
